import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const $ = window.$;

export default class ModalSpecialGift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        }

        this.sendSpecialGift = this.sendSpecialGift.bind(this);
    }

    sendSpecialGift() {
        let type = $('#type').find('option:selected').val();
        let number = $('#number').val().trim();
        let value = Number(type + number);
        if (!type || value == NaN) {
            return toast.error("Sai giá trị");
        }

        axios.post(global.config.apiDomain + '/rest/userSpecialGift/' + this.props.user.facebookId + '/' + value)
          .then(res => {
            console.log(res);
            if (res.data.status == "OK") {
                $("#modalSpecialGift").modal("hide");
              toast.success(res.data.message);
              this.props.resetData();
            } else {
              toast.error(res.data.message);
            }
          });
    }


    render() {
        const { loading } = this.state;


        return (
            <div>
                <div className="modal fade" id="modalSpecialGift" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Thay đổi Thẻ xử lý</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div id="type" className="row mb-2">
                                    <div className="col-3">
                                        <label>Hành động</label>
                                    </div>
                                    <div className="col-9">
                                        <select
                                            className="form-control"
                                            type="text"
                                            id="type"
                                        >
                                            <option value="">Chọn</option>
                                            <option value="+">Tăng Thẻ</option>
                                            <option value="-">Giảm Thẻ</option>
                                        </select>
                                    </div>
                                </div>

                                <div id="money" className="row mb-2">
                                    <div className="col-3">
                                        <label>Số lượng</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            placeholder="Nhập số điểm"
                                            className="form-control"
                                            id="number" />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {loading ?
                                    (
                                        <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Xác nhận...
                                        </button>
                                    ) :
                                    (
                                        <button
                                            style={{ width: "120px" }}
                                            type="button"
                                            className="btn btn-red"
                                            onClick={this.sendSpecialGift}>Xác nhận</button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}